import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Header from '../../../components/Header';
import { useUser } from '../../../contexts/userContext';
import { useColumns } from '../../../contexts/columnsContext';
import { useCard } from '../../../contexts/cardContext';

import axios from 'axios';
import { apiUrl } from '../../../config/apiConfig';
import api from '../../../services/api';

import './style.css';
import Column from '../../Column';
import Card from '../../Card';

import { DragDropContext } from 'react-beautiful-dnd';
import PreviewCard from '../../PreviewCard';
import GoogleCalendario from '../../GoogleCalendario';
import Select from '../../Select';
import BemVindo from '../../BemVindo';

import { MdOutlineFilterList, MdGroups, MdOutlineSearch, MdOutlineUpdate } from "react-icons/md";
import { MdPerson, MdPhone, MdAttachMoney, MdDescription, MdLocalShipping, MdLocationCity, MdLabel, MdPublic } from 'react-icons/md';


import ImportExcel from '../../ImportExcel';
import ImportExcelSuiteFlow from '../../ImportExcelSuiteFlow';
import { RiFileExcel2Line } from "react-icons/ri";

import { BsCalendarDate } from "react-icons/bs";

import logoDefault from '../../../assets/logo-suite-flow.ico'
import Vendas from '../../Vendas';

import ExcelJS from 'exceljs';

import { useNavigate } from 'react-router-dom';

import logoBazze from '../../../assets/b_branco.png'
import { isWhatsappMetaReviewerUser } from '../../../config/whatsappMetaFeature';



function askNotificationPermission() {
  // Verifica se o dispositivo é iOS e se está no Safari, pois o suporte é limitado
  const isIos = /iPhone|iPad|iPod/.test(navigator.userAgent) && !window.MSStream;

  if (isIos) {
    console.warn('Notificações push não são suportadas em dispositivos iOS via Service Workers.');
    return Promise.reject(new Error('iOS não suporta notificações push.'));
  }

  // Solicita permissão de notificações
  return Notification.requestPermission().then(permissionResult => {
    if (permissionResult !== 'granted') {
      //throw new Error('Permissão para notificações não concedida');
    } else {
      //console.log('Permissão para notificações concedida.');
    }
  }).catch(error => {
    console.error('Erro ao solicitar permissão para notificações:', error);
  });
}




// Converter chave VAPID para Uint8Array
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}



function HomePage() {

  const { user, listAllUsers, openCloseImportExcelEntidades, openCloseImportExcelSuiteFlow, afilhadosList, getAccessLevel, userAvatar, empresa } = useUser();
  const isMetaReviewer = isWhatsappMetaReviewerUser(user?.id);
  const visibleAfilhadosList = useMemo(() => (
    [5, 8].includes(Number(user?.access_level))
      ? (listAllUsers || []).filter((item) => Number(item.id) !== Number(user?.id))
      : (afilhadosList || [])
  ), [user?.access_level, user?.id, listAllUsers, afilhadosList]);
  const { setEditableColumns, setColumnsUser, setColumns, filteredColumnsBuscaLocal, setFilteredColumnsBuscaLocal, selectedEtiqueta, setSelectedEtiqueta, listaEtiquetas, setListaEtiquetas, showSharedCards, setShowSharedCards, editableColumns, columnsUser, setLoadingResult, setLoadingModal, selectedAfilhados, setSelectedAfilhados, dataInicial, setDataInicial, dataFinal, setDataFinal, dataType, setDataType, orderBy, setOrderBy, isAscending, setIsAscending, localSearchTerm, handleLocalSearch, setores, selectedSetores, setSelectedSetores, handleSetorChange, listaCardsFiltradosLocalmente, tipoBuscaLocal, setTipoBuscaLocal, nivelBuscaCards, setNivelBuscaCards, buscaCombinadaComColuna, setBuscaCombinadaComColuna, boards, setBoards, selectedAnexoSetor, setSelectedAnexoSetor, selectedTipoCliente, setSelectedTipoCliente, listaTiposCliente } = useColumns();
  const { setSelectedTemperatures, toggleTemperatureSelection, selectedTemperatures, fetchCards, addHistoricoCardContext, cards, setCards, previewSearchCards, setPreviewSearchCards, searchTerm, setSearchTerm, setCurrentCardData, setOpenCloseUpdateCard, fetchAllFilteredCardsForExport } = useCard();

  const [openCloseSearchModal, setOpenCloseSearchModal] = useState(false);
  const [openCloseSelectAfilhadosModal, setOpenCloseSelectAfilhadosModal] = useState(false);
  const [openCloseSelectDateModal, setOpenCloseSelectDateModal] = useState(false);
  const [openCloseFilterModal, setOpenCloseFilterModal] = useState(false);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const navigate = useNavigate();

  const [loadingCards, setLoadingCards] = useState(false); // Adicione esta linha
  const [loadingBoards, setLoadingBoards] = useState(true); // Novo estado para loading dos boards


  const [selectedBoardId, setSelectedBoardId] = useState('');




  const [searchType, setSearchType] = useState('name'); // Estado para armazenar o tipo de pesquisa selecionado


  const vapidPublicKey = 'BB7PgWv8ONF467L4KP_BslDx3yXteeIN5irXGyvf9DuCv_gnoEojq-gOHQkuU3JV1a1ti0oLUe34OX_D9YlWZj4'; // Substitua pela sua chave VAPID real

  useEffect(() => {
    // Solicitar permissão de notificações ao carregar o componente
    askNotificationPermission()
      .then(() => {
        if ('serviceWorker' in navigator) {
          //console.log("Suporte a Service Worker detectado. Registrando...");

          navigator.serviceWorker.register('/service-worker.js')
            .then(registration => {
              //console.log('Service Worker registrado com sucesso:', registration);

              // Verifica se o Push Manager está disponível
              return registration.pushManager.getSubscription()
                .then(subscription => {
                  if (subscription === null) {
                    // console.log('Nenhuma inscrição existente, inscrevendo usuário...');
                    return registration.pushManager.subscribe({
                      userVisibleOnly: true,
                      applicationServerKey: urlBase64ToUint8Array(vapidPublicKey),
                    });
                  } else {
                    // console.log('Usuário já está inscrito no Push Manager:', subscription);
                    return subscription;
                  }
                })
                .then(subscription => {
                  // Enviar a assinatura para o backend
                  sendSubscriptionToBackend(subscription, user.id);
                });
            })
            .catch(error => {
              console.error('Falha ao registrar o Service Worker:', error);
            });
        }
      })
      .catch(error => {
        console.error('Erro ao solicitar permissão de notificações ou registrar service worker:', error);
      });
  }, []);





  // useEffect(() => {
  //   setTipoBuscaLocal('')

  //   handleLocalSearch('')
  // }, []);




  // Função para enviar a inscrição para o backend
  // const sendSubscriptionToBackend = async (subscription, userId) => {
  //   try {
  //     //console.log('Enviando inscrição ao backend...', subscription);
  //     const response = await axios.post(`${apiUrl}/notifications/subscribe`, {
  //       userId, // Envia o userId junto com a subscription
  //       subscription,
  //     }, {
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //     });
  //     // console.log('Inscrição salva no servidor:', response.data);
  //   } catch (error) {
  //     console.error('Falha ao enviar inscrição para o servidor:', error);
  //   }
  // };

  // Função para enviar a inscrição para o backend
  const sendSubscriptionToBackend = async (subscription, userId) => {
    try {
      // console.log('Enviando inscrição ao backend...', subscription);
      const response = await api.post(
        "/notifications/subscribe",
        {
          userId, // Envia o userId junto com a subscription
          subscription,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // console.log('Inscrição salva no servidor:', response.data);
    } catch (error) {
      console.error("Falha ao enviar inscrição para o servidor:", error);
    }
  };













  // const fetchCardsByName = async () => {
  //   setLoadingSearch(true);
  //   if (searchTerm.trim()) {
  //     try {
  //       const response = await axios.get(`${apiUrl}/card/search`, {
  //         params: {
  //           searchType, // Passa o tipo de pesquisa selecionado
  //           searchTerm, // Termo de busca
  //           entityId: user.id,
  //           empresaId: user.empresa_id,
  //         }
  //       });
  //       setPreviewSearchCards(response.data);
  //       setLoadingSearch(false);
  //     } catch (error) {
  //       console.error('Failed to fetch cards:', error);
  //       setLoadingSearch(false);
  //     }
  //   } else {
  //     setPreviewSearchCards([]);
  //   }
  // };

  const fetchCardsByName = async () => {
    setLoadingSearch(true);

    if (searchTerm.trim()) {
      try {
        const response = await api.get("/card/search", {
          params: {
            searchType, // Passa o tipo de pesquisa selecionado
            searchTerm, // Termo de busca
            entityId: user.id,
            empresaId: user.empresa_id,
          },
        });

        setPreviewSearchCards(response.data);
      } catch (error) {
        console.error("Erro ao buscar cards:", error);
      } finally {
        setLoadingSearch(false);
      }
    } else {
      setPreviewSearchCards([]);
      setLoadingSearch(false);
    }
  };






  const handleSearchClick = () => {
    if (searchTerm.length < 2) return;
    setPreviewSearchCards([]);
    fetchCardsByName();
  };

  function getCardData(card) {
    setCurrentCardData(card);
    setOpenCloseUpdateCard(true);
    setSearchTerm('');
  }

  const getNameColumnCard = (idColumn) => {
    if (!columnsUser) {
      return 'Dados ainda estão carregando...';
    }

    const nameColumn = columnsUser.find((item) => item.id === idColumn);
    return nameColumn ? nameColumn.name : 'Nome não encontrado';
  };


  // const handleOnDragEnd = async (result) => {
  //   const { destination, source, draggableId } = result;

  //   const startCards = [...cards];

  //   if (!destination || (destination.droppableId === source.droppableId && destination.index === source.index)) {
  //     return; // Não faz nada se não há destino ou se o card foi largado na mesma posição
  //   }

  //   const { cardData, block_column } = JSON.parse(draggableId);
  //   const currentCardId = cardData.card_id;
  //   const currentColumnId = parseInt(source.droppableId, 10);
  //   const newColumnId = parseInt(destination.droppableId, 10);

  //   // // Nova verificação adicionada
  //   // if (!cardData.city || !cardData.state) {
  //   //   alert('Não é possível mover o card. Cidade e/ou Estado não preenchidos.');
  //   //   return;
  //   // }


  //   // Verificação para Cidade, Estado e Origem
  //   if (!cardData.city || !cardData.state || !cardData.origem || cardData.origem == 'Sem Origem') {
  //     const missingField = !cardData.city ? 'Campo cidade' : !cardData.state ? 'Campo estado' : ' Campo origem';
  //     alert(`Não é possível mover o card. ${missingField} não preenchido.`);
  //     return;
  //   }



  //   if (!getAccessLevel('coluna')) {
  //     const confirmDelete = window.alert('Não autorizado pelo Administrador!');
  //     return
  //   }

  //   if (block_column) {
  //     alert('Você não pode mover este card.');
  //     return;
  //   }

  //   // Verifica se a coluna de destino está na lista de colunas editáveis
  //   const editableColumnIds = editableColumns.map(column => column.columnId);

  //   // Verifica se a coluna atual do card está na lista de colunas editáveis
  //   if (!editableColumnIds.includes(currentColumnId)) {
  //     alert('Você não tem permissão para mover o card a partir desta coluna.');
  //     return;
  //   }

  //   // Verifica se a coluna de destino está na lista de colunas editáveis
  //   if (!editableColumnIds.includes(newColumnId)) {
  //     alert('Você não tem permissão para mover o card para esta coluna.');
  //     return;
  //   }

  //   const userConfirmed = window.confirm(`Você tem certeza que deseja alterar?`);
  //   if (!userConfirmed) {
  //     return;
  //   }

  //   try {
  //     setLoadingModal(true);
  //     setLoadingResult('Alterando Coluna...');
  //     // Chama a API para atualizar o column_id no banco de dados
  //     const response = await axios.post(`${apiUrl}/card/update-column`, {
  //       cardId: currentCardId,
  //       columnId: newColumnId
  //     });

  //     if (response.data) {
  //       addHistoricoCardContext(`Coluna alterada para ${getNameColumnCard(newColumnId)}`, currentCardId, user.id);


  //       updateCardEtiqueta(cardData, null);


  //     } else {
  //       throw new Error('No data returned');
  //     }

  //     // Atualização otimista: Atualiza o estado imediatamente
  //     const newCards = cards.map(card => {
  //       if (card.card_id === currentCardId) {
  //         return { ...card, column_id: newColumnId }; // Assume que a propriedade que define a coluna é `column_id`
  //       }
  //       return card;
  //     });
  //     setCards(newCards);

  //     setLoadingModal(false);
  //     setLoadingResult('');
  //   } catch (error) {
  //     setLoadingResult('Erro ao alterar Card de Coluna!');
  //     console.error('Failed to update card column:', error);
  //     // Reverte a mudança otimista em caso de erro
  //     setCards(startCards);
  //     alert('Failed to move card, please try again.');
  //   }
  // };


  const handleOnDragEnd = async (result) => {
    const { destination, source, draggableId } = result;

    const startCards = [...cards];

    if (!destination || (destination.droppableId === source.droppableId && destination.index === source.index)) {
      return; // Não faz nada se não há destino ou se o card foi largado na mesma posição
    }

    const { cardData, block_column } = JSON.parse(draggableId);
    const currentCardId = cardData.card_id;
    const currentColumnId = parseInt(source.droppableId, 10);
    const newColumnId = parseInt(destination.droppableId, 10);

    // Verificação para Cidade, Estado, Origem e Fone
    const temLocalizacao = (cardData.city && cardData.state) || cardData.cidade_estado_internacional;
    if (!temLocalizacao || !cardData.origem || cardData.origem === "Sem Origem" || !cardData.fone || cardData.fone.toString().trim() === '') {
      const missingField = !temLocalizacao
        ? "Campo cidade/estado"
        : (!cardData.origem || cardData.origem === "Sem Origem")
          ? "Campo origem"
          : "Campo fone";
      alert(`Não é possível mover o card. ${missingField} não preenchido.`);
      return;
    }

    if (!cardData.tipo_cliente_id) {
      alert("Não é possível mover o card. Campo Tipo de Cliente não preenchido.");
      return;
    }

    if (!getAccessLevel("coluna")) {
      alert("Não autorizado pelo Administrador!");
      return;
    }

    if (block_column) {
      const targetColumnName = getNameColumnCard(newColumnId);
      if (targetColumnName !== "Em Contato" && targetColumnName !== "Sem Retorno") {
        alert("Não é possível mover o card. O card está bloqueado e só pode ser movido para as colunas 'Em Contato' ou 'Sem Retorno'.");
        return;
      }
    }

    // Verifica se a coluna de destino está na lista de colunas editáveis
    const editableColumnIds = editableColumns.map((column) => column.columnId);

    // Verifica se a coluna atual do card está na lista de colunas editáveis
    if (!editableColumnIds.includes(currentColumnId)) {
      alert("Você não tem permissão para mover o card a partir desta coluna.");
      return;
    }

    // Verifica se a coluna de destino está na lista de colunas editáveis
    if (!editableColumnIds.includes(newColumnId)) {
      alert("Você não tem permissão para mover o card para esta coluna.");
      return;
    }

    const userConfirmed = window.confirm("Você tem certeza que deseja alterar?");
    if (!userConfirmed) {
      return;
    }

    try {
      setLoadingModal(true);
      setLoadingResult("Alterando Coluna...");

      // Chama a API para atualizar o column_id no banco de dados
      const response = await api.post("/card/update-column", {
        cardId: currentCardId,
        columnId: newColumnId,
      });

      if (response.data) {
        addHistoricoCardContext(
          `Coluna alterada para ${getNameColumnCard(newColumnId)}`,
          currentCardId,
          user.id
        );

        updateCardEtiqueta(cardData, null);
      } else {
        throw new Error("Nenhum dado retornado da API.");
      }

      // Atualização otimista: Atualiza o estado imediatamente
      const newCards = cards.map((card) =>
        card.card_id === currentCardId ? { ...card, column_id: newColumnId } : card
      );
      setCards(newCards);

      setLoadingModal(false);
      setLoadingResult("");
    } catch (error) {
      setLoadingResult("Erro ao alterar Card de Coluna!");
      console.error("Erro ao atualizar a coluna do card:", error);
      // Reverte a mudança otimista em caso de erro
      setCards(startCards);
      alert("Falha ao mover o card, tente novamente.");
    }
  };








  // const updateCardEtiqueta = async (cardData, etiqueta) => {




  //   try {

  //     const response = await axios.post(`${apiUrl}/card/update-etiqueta`, {
  //       cardId: cardData.card_id,
  //       etiqueta_id: etiqueta,
  //     });



  //     setCards(prevCards => prevCards.map(card => card.card_id === cardData.card_id ? { ...card, ...response.data } : card));
  //     setPreviewSearchCards(prevCards => prevCards.map(card => card.card_id === cardData.card_id ? { ...card, ...response.data } : card));

  //   } catch (error) {
  //     console.log('Erro ao alterar Etiqueta!');

  //   }
  // };
  const updateCardEtiqueta = async (cardData, etiqueta) => {
    try {
      const response = await api.post("/card/update-etiqueta", {
        cardId: cardData.card_id,
        etiqueta_id: etiqueta,
      });

      setCards((prevCards) =>
        prevCards.map((card) =>
          card.card_id === cardData.card_id ? { ...card, ...response.data } : card
        )
      );

      setPreviewSearchCards((prevCards) =>
        prevCards.map((card) =>
          card.card_id === cardData.card_id ? { ...card, ...response.data } : card
        )
      );
    } catch (error) {
      console.error("Erro ao alterar Etiqueta:", error);
    }
  };








  useEffect(() => {
    //setPreviewSearchCards([])
  }, [searchTerm]);

  function clearSearchTerm() {
    setSearchTerm('');
    setPreviewSearchCards([]);
    setOpenCloseSearchModal(!openCloseSearchModal)
  }

  // const handleSelectChange = (id) => {
  //   setSelectedAfilhados(prevSelected =>
  //     prevSelected.includes(id)
  //       ? prevSelected.filter(afilhadoId => afilhadoId !== id)
  //       : [...prevSelected, id]
  //   );
  // };

  const handleSelectChange = (id) => {
    setSelectedAfilhados(prevSelected =>
      prevSelected.includes(id)
        ? prevSelected.filter(afilhadoId => afilhadoId !== id)
        : [...prevSelected, id]
    );
  };




  // const handleSelectAll = () => {
  //   if (selectedAfilhados.length === afilhadosList.length + 1) {
  //     setSelectedAfilhados([]);
  //   } else {
  //     setSelectedAfilhados([user.id, ...afilhadosList.map(afilhado => afilhado.id)]);
  //   }
  // };

  // const handleSelectAll = () => {
  //   if (selectedAfilhados.length === afilhadosList.length + 1 && showSharedCards) {
  //     setSelectedAfilhados([]);
  //     setShowSharedCards(false);  // Desativa a visualização dos compartilhados ao desmarcar todos
  //   } else {
  //     setSelectedAfilhados([user.id, ...afilhadosList.map(afilhado => afilhado.id)]);
  //     setShowSharedCards(true);   // Ativa a visualização dos compartilhados ao selecionar todos
  //   }
  // };

  const handleSelectAll = () => {


    if (selectedAfilhados.length === visibleAfilhadosList.length + 1) {
      setSelectedAfilhados([]); // Desmarcar todos
      setShowSharedCards(false);

    } else {
      setSelectedAfilhados([user.id, ...visibleAfilhadosList.map(afilhado => afilhado.id)]); // Selecionar todos
      setShowSharedCards(true);

    }
  };



  useEffect(() => {
    if (user && !selectedAfilhados.includes(user.id)) {
      setSelectedAfilhados([user.id]);
    }
  }, [user]);



  const [tempDataInicial, setTempDataInicial] = useState(dataInicial);
  const [tempDataFinal, setTempDataFinal] = useState(dataFinal);
  const [tempDataType, setTempDataType] = useState(dataType);

  // Sincroniza estado temporário quando contexto muda (ex: reloadPage reseta datas)
  useEffect(() => { setTempDataInicial(dataInicial); }, [dataInicial]);
  useEffect(() => { setTempDataFinal(dataFinal); }, [dataFinal]);
  useEffect(() => { setTempDataType(dataType); }, [dataType]);

  const handleTempDateChange = (e) => {
    const { name, value } = e.target;
    if (name === "tempDataInicial") {
      setTempDataInicial(value);
    } else if (name === "tempDataFinal") {
      setTempDataFinal(value);
    }
  };

  const handleUpdateDates = () => {
    setDataInicial(tempDataInicial);
    setDataFinal(tempDataFinal);
    setDataType(tempDataType);
    // O RELOAD useEffect detecta as mudanças e recarrega automaticamente
  };




  // const exportarTabelasExcel = async () => {

  //   const userConfirmed = window.confirm(`Exportar Planilhas?`);
  //   if (!userConfirmed) {
  //     return;
  //   }

  //   const tables = ['cards', 'users', 'modulo_esquadrias', 'history', 'tasks'];

  //   for (const table of tables) {
  //     try {
  //       const response = await axios.post(`${apiUrl}/users/${table}`, {
  //         empresa_id: user.empresa_id,
  //       });
  //       const data = response.data;

  //       if (data.length > 0) {
  //         const workbook = new ExcelJS.Workbook();
  //         const worksheet = workbook.addWorksheet(table);

  //         worksheet.columns = Object.keys(data[0]).map((key) => ({
  //           header: key,
  //           key: key,
  //           width: 20,
  //         }));

  //         data.forEach((row) => {
  //           worksheet.addRow(row);
  //         });

  //         const buffer = await workbook.xlsx.writeBuffer();
  //         const blob = new Blob([buffer], {
  //           type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  //         });

  //         const url = window.URL.createObjectURL(blob);
  //         const link = document.createElement('a');
  //         link.href = url;
  //         link.setAttribute('download', `${table}.xlsx`);
  //         document.body.appendChild(link);
  //         link.click();
  //       }
  //     } catch (error) {
  //       console.error(`Erro ao exportar tabela ${table}:`, error);
  //     }
  //   }
  // };



  // function reloadPage() {
  //   handleLocalSearch('')
  //   window.location.reload();
  // }

  function reloadPage() {
    setSelectedTemperatures([]);
    setTipoBuscaLocal('name');
    setNivelBuscaCards(0);
    setSelectedEtiqueta(null);
    handleLocalSearch('');
    // O RELOAD useEffect detecta as mudanças acima e recarrega automaticamente
  }










  const [localSearchInput, setLocalSearchInput] = useState('');

  // Função para atualizar o termo de busca local
  const onLocalSearch = () => {
    handleLocalSearch(localSearchInput);
  };


  const [isLocalSearchVisible, setIsLocalSearchVisible] = useState(true);




  const [afilhadoSearchTerm, setAfilhadoSearchTerm] = useState('');

  const handleAfilhadoSearch = (searchTerm) => {
    setAfilhadoSearchTerm(searchTerm);
  };

  const filteredAfilhadosList = visibleAfilhadosList.filter(afilhado =>
    afilhado.username.toLowerCase().includes(afilhadoSearchTerm.toLowerCase())
  );






  const handleSelectAllSetores = () => {
    setSelectedSetores(setores);
  };

  const handleDeselectAllSetores = () => {
    setSelectedSetores([]);
  };



  const selectAllAfilhados = useCallback(() => {
    setSelectedAfilhados([user.id, ...visibleAfilhadosList.map(afilhado => afilhado.id)]);
  }, [setSelectedAfilhados, user?.id, visibleAfilhadosList]);


  useEffect(() => {
    if (user && visibleAfilhadosList.length > 0) {
      selectAllAfilhados();
    }
  }, [user, visibleAfilhadosList, selectAllAfilhados]);



  // function reloadPage() {
  //   setSelectedTemperatures([]); // Garante que o estado é resetado

  //   setTipoBuscaLocal('name')
  //   setNivelBuscaCards(0)
  //   //setSelectedAfilhados([]);
  //   setSelectedEtiqueta(null)
  //   handleLocalSearch('');    // Limpa busca local
  //   setCards([]);              // Limpa o estado dos cards
  //   fetchCards(dataInicial, dataFinal); // Recarrega os cards
  //   //window.location.reload();  // Força o recarregamento da página
  //   //navigate('/');
  // }

  useEffect(() => {
    if (user) {
      setTipoBuscaLocal('name')
      setNivelBuscaCards(0)
      //setSelectedAfilhados([]);
      setSelectedEtiqueta(null)
      handleLocalSearch('');    // Limpa busca local
      setCards([]);              // Limpa o estado dos cards
      //fetchCards(dataInicial, dataFinal); // Recarrega os cards
      //window.location.reload();  // Força o recarregamento da página
      //navigate('/');
    }
  }, [user]);





  //-----------------------------------------------
  //-----------------------------------------------
  //-----------------------------------------------
  //----------------- ENVIAR EMAIL ----------------
  //-----------------------------------------------
  //-----------------------------------------------
  //-----------------------------------------------

  // const handleSendEmail = async () => {


  //   // Dados do e-mail
  //   const emailData = {
  //     to: empresa.email_solicitacao_pedidos, // Alterar para o e-mail do destinatário
  //     subject: 'Novo Pedido Criado',
  //     text: 'Um novo pedido foi criado.',
  //   };

  //   try {
  //     const response = await axios.post(`${apiUrl}/users/send-email/${empresa.id}`, emailData);

  //   } catch (err) {

  //   } finally {

  //   }
  // };




  const handleSendEmail = async () => {
    // Dados do e-mail
    const emailData = {
      to: empresa.email_solicitacao_pedidos, // Alterar para o e-mail do destinatário
      subject: "Novo Pedido Criado",
      text: "Um novo pedido foi criado.",
    };

    try {
      await api.post(`/users/send-email/${empresa.id}`, emailData);
    } catch (err) {
      console.error("Erro ao enviar e-mail:", err);
    }
  };









  const [showPotentialSales, setShowPotentialSales] = useState(false);
  const [potentialSalesData, setPotentialSalesData] = useState([]);

  // const fetchPotentialSalesData = async () => {
  //   try {
  //     const response = await axios.get(`${apiUrl}/users/potential-sales`, {
  //       params: {
  //         userId: user.id,
  //         empresaId: user.empresa_id,
  //       }
  //     });


  //     // Verifica se a resposta é um array
  //     if (Array.isArray(response.data)) {
  //       setPotentialSalesData(response.data);
  //     } else {
  //       // Se a resposta não for um array, define um array vazio ou lida de outra forma
  //       setPotentialSalesData([]);
  //       console.error('Resposta inesperada do servidor:', response.data);
  //     }
  //   } catch (error) {
  //     console.error('Erro ao buscar dados de vendas potenciais:', error);
  //     setPotentialSalesData([]); // Em caso de erro, define um array vazio para evitar o erro de map
  //   }
  // };
  const fetchPotentialSalesData = async () => {
    try {
      const response = await api.get("/users/potential-sales", {
        params: {
          userId: user.id,
          empresaId: user.empresa_id,
        },
      });

      // Verifica se a resposta é um array
      if (Array.isArray(response.data)) {
        setPotentialSalesData(response.data);
      } else {
        // Se a resposta não for um array, define um array vazio ou lida de outra forma
        setPotentialSalesData([]);
        console.error("Resposta inesperada do servidor:", response.data);
      }
    } catch (error) {
      console.error("Erro ao buscar dados de vendas potenciais:", error);
      setPotentialSalesData([]); // Em caso de erro, define um array vazio para evitar o erro de map
    }
  };






  const [isSearchLocalVisible, setIsSearchLocalVisible] = useState(false);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.search-card-input-local')) {
        //setIsSearchLocalVisible(false); // Esconde a div ao clicar fora do input
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);



  const [showGoogleCalendar, setShowGoogleCalendar] = useState(false);





















  // useEffect(() => {

  //   console.log(listaCardsFiltradosLocalmente)

  // }, [listaCardsFiltradosLocalmente])




  // Função para exportar os cards filtrados localmente
  // const exportarCardsFiltrados = async () => {
  //   if (listaCardsFiltrados.length === 0) {
  //     alert('Não há cards filtrados para exportar.');
  //     return;
  //   }

  //   try {
  //     const workbook = new ExcelJS.Workbook();
  //     const worksheet = workbook.addWorksheet('Cards Filtrados');

  //     // Definindo as colunas do Excel com base na estrutura da tabela 'cards'
  //     worksheet.columns = [
  //       { header: 'ID', key: 'card_id', width: 10 },
  //       { header: 'ColumnID', key: 'column_id', width: 10 },
  //       { header: 'Coluna', key: 'column_name', width: 10 },
  //       { header: 'Nome', key: 'name', width: 30 },
  //       { header: 'Estado', key: 'state', width: 20 },
  //       { header: 'Cidade', key: 'city', width: 20 },
  //       { header: 'Telefone', key: 'fone', width: 20 },
  //       { header: 'Email', key: 'email', width: 30 },
  //       { header: 'Documento', key: 'document_number', width: 20 },
  //       { header: 'Custo', key: 'cost_value', width: 15 },
  //       { header: 'Valor de Venda', key: 'sale_value', width: 15 },
  //       { header: 'Status', key: 'status', width: 20 },
  //       { header: 'Data de Status', key: 'status_date', width: 20 },
  //       { header: 'Data de Criação', key: 'created_at', width: 20 },
  //       { header: 'Data de Atualização', key: 'updated_at', width: 20 },
  //       { header: 'CPF', key: 'cpf', width: 20 },
  //       { header: 'Origem', key: 'origem', width: 20 },
  //       { header: 'Produto', key: 'produto', width: 20 },
  //       { header: 'Número do Pedido', key: 'pedido_number', width: 20 },
  //       { header: 'Responsável', key: 'responsavel', width: 30 },
  //       { header: 'Temperatura', key: 'temperatura', width: 70 }
  //     ];

  //     // Adicionando as linhas com os dados dos cards filtrados
  //     listaCardsFiltrados.forEach(card => {
  //       worksheet.addRow({
  //         card_id: card.card_id,
  //         column_id: card.column_id,
  //         column_name: getNameColumnCard(card.column_id),
  //         name: card.name,
  //         state: card.state,
  //         city: card.city,
  //         fone: card.fone,
  //         email: card.email,
  //         document_number: card.document_number,
  //         cost_value: card.cost_value,
  //         sale_value: card.sale_value,
  //         status: card.status,
  //         status_date: card.status_date,
  //         created_at: card.created_at,
  //         updated_at: card.updated_at,
  //         cpf: card.cpf,
  //         origem: card.origem,
  //         produto: card.produto,
  //         pedido_number: card.pedido_number,
  //         responsavel: card.responsavel,
  //         temperatura: card.temperatura_card === 1 ? 'Frio' : card.temperatura_card === 2 ? 'Morno' : card.temperatura_card === 3 ? 'Quente' : 'N/A'
  //       });
  //     });

  //     const buffer = await workbook.xlsx.writeBuffer();
  //     const blob = new Blob([buffer], {
  //       type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  //     });

  //     const url = window.URL.createObjectURL(blob);
  //     const link = document.createElement('a');
  //     link.href = url;
  //     link.setAttribute('download', 'cards_filtrados.xlsx');
  //     document.body.appendChild(link);
  //     link.click();
  //   } catch (error) {
  //     console.error('Erro ao exportar cards filtrados:', error);
  //   }
  // };


  const getUsernameById = (entityId) => {

    if (!user) {
      return 'Erro: Dados necessários não estão disponíveis.';
    }

    const entidade = listAllUsers.find(afilhado => afilhado.id === entityId);
    if (entidade && entidade.username) {
      return entidade.username;
    }

    if (entityId === user.id) {
      return user.username;
    }

    return 'id não encontrado';
  };

  const [isExportingCards, setIsExportingCards] = useState(false);

  const exportarCardsFiltrados = async () => {
    try {
      setIsExportingCards(true);
      const exportFilterOverrides = buscaLocal.trim() && tipoBuscaLocal
        ? { tipoBuscaLocal, localSearchTerm: buscaLocal.trim() }
        : {};
      const cardsParaExportar = await fetchAllFilteredCardsForExport(exportFilterOverrides);

      if (cardsParaExportar.length === 0) {
        alert('Não há cards filtrados para exportar.');
        return;
      }

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Cards Filtrados');

      // Definindo as colunas do Excel com base na estrutura da tabela 'cards'
      worksheet.columns = [
        { header: 'ID', key: 'card_id', width: 10 },
        { header: 'ColumnID', key: 'column_id', width: 10 },
        { header: 'Coluna', key: 'column_name', width: 10 },
        { header: 'Nome', key: 'name', width: 30 },
        { header: 'Estado', key: 'state', width: 20 },
        { header: 'Cidade', key: 'city', width: 20 },
        { header: 'Telefone', key: 'fone', width: 20 },
        { header: 'Email', key: 'email', width: 30 },
        { header: 'Documento', key: 'document_number', width: 20 },
        { header: 'Custo', key: 'cost_value', width: 15 },
        { header: 'Valor de Venda', key: 'sale_value', width: 15 },
        { header: 'Status', key: 'status', width: 20 },
        { header: 'Data de Status', key: 'status_date', width: 20 },
        { header: 'Data de Criação', key: 'created_at', width: 20 },
        { header: 'Data de Atualização', key: 'updated_at', width: 20 },
        { header: 'CPF', key: 'cpf', width: 20 },
        { header: 'Origem', key: 'origem', width: 20 },
        { header: 'Produto', key: 'produto', width: 20 },
        { header: 'Número do Pedido', key: 'pedido_number', width: 20 },
        { header: 'Responsável', key: 'responsavel', width: 30 },
        { header: 'Temperatura', key: 'temperatura', width: 70 },
        { header: 'EntidadeID', key: 'entidadeID', width: 30 },
        { header: 'Entidade', key: 'entidade', width: 30 } // Nova coluna para Entidade

      ];

      // Adicionando as linhas com os dados dos cards filtrados
      cardsParaExportar.forEach(card => {
        worksheet.addRow({
          card_id: card.card_id,
          column_id: card.column_id,
          column_name: getNameColumnCard(card.column_id),
          name: card.name,
          state: card.state,
          city: card.city,
          fone: card.fone,
          email: card.email,
          document_number: card.document_number,
          cost_value: card.cost_value,
          sale_value: card.sale_value,
          status: card.status,
          status_date: card.status_date,
          created_at: card.created_at,
          updated_at: card.updated_at,
          cpf: card.cpf,
          origem: card.origem,
          produto: card.produto,
          pedido_number: card.pedido_number,
          responsavel: card.responsavel,
          temperatura: card.temperatura_card === 1 ? 'Frio' : card.temperatura_card === 2 ? 'Morno' : card.temperatura_card === 3 ? 'Quente' : 'N/A',
          entidadeID: card.entity_id || 'Não informado',
          entidade: getUsernameById(card.entity_id),

        });
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'cards_filtrados.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      alert(`Excel exportado com sucesso: ${cardsParaExportar.length} cards.`);
    } catch (error) {
      console.error('Erro ao exportar cards filtrados:', error);
      alert('Não foi possível exportar os cards filtrados. Tente novamente.');
    } finally {
      setIsExportingCards(false);
    }
  };





  // FILTRO BUSCA LOCAL

  const [buscaLocal, setBuscaLocal] = useState('');
  function updateBuscaLocal() {
    handleLocalSearch(buscaLocal)
    setIsSearchLocalVisible(false)
  }







  // const updateTemperaturaCard = (temperatura) => {

  //   setTemperaturaCardFilter(temperatura)

  //   if(temperatura = temperaturaCardFilter){
  //     setTemperaturaCardFilter('')

  //   }

  // };



  function tipoDeBuscaLocal(tipo) {
    setTipoBuscaLocal(tipo);
    // O RELOAD useEffect detecta a mudança de tipoBuscaLocal e recarrega automaticamente
  }


  const handleRadioClick = () => {
    // Alterna o estado entre verdadeiro e falso
    setBuscaCombinadaComColuna((prevState) => !prevState);
  };














  const [tooltip, setTooltip] = useState({ visible: false, x: 0, y: 0, text: '' });
  const [tooltipTimeout, setTooltipTimeout] = useState(null);
  const [hideTimeout, setHideTimeout] = useState(null);

  const showTooltip = (e, text) => {
    const rect = e.target.getBoundingClientRect();

    // Cancela timeouts anteriores
    if (tooltipTimeout) clearTimeout(tooltipTimeout);
    if (hideTimeout) clearTimeout(hideTimeout);

    // Aguarda 3 segundos antes de exibir a tooltip
    const timeoutId = setTimeout(() => {
      setTooltip({
        visible: true,
        x: rect.left + rect.width / 2, // Centraliza no botão
        y: rect.top - 10, // Posiciona acima do botão
        text,
      });

      // Define um timeout para esconder a tooltip após 3 segundos
      const hideId = setTimeout(() => {
        setTooltip({ visible: false, x: 0, y: 0, text: '' });
      }, 3000);

      setHideTimeout(hideId);
    }, 1000);

    setTooltipTimeout(timeoutId);
  };

  const hideTooltip = () => {
    // Cancela qualquer timeout ativo
    if (tooltipTimeout) clearTimeout(tooltipTimeout);
    if (hideTimeout) clearTimeout(hideTimeout);

    setTooltip({ visible: false, x: 0, y: 0, text: '' });
  };


  useEffect(() => {
    if (selectedTemperatures.length === 0) {
      document.querySelectorAll('.btn-temperatura').forEach(button => {
        button.classList.remove('selected');
      });
    }
  }, [selectedTemperatures]);



  // Efeito para definir o primeiro board como padrão quando a lista de boards for carregada
  useEffect(() => {
    if (boards && boards.length > 0 && !selectedBoardId) {
      setSelectedBoardId(boards[0].id.toString());
    }
  }, [boards]);



  useEffect(() => {
    const fetchBoards = async () => {
      if (user && user.empresa_id) {
        setLoadingBoards(true);
        try {
          const response = await api.get(`/users/boards/${user.empresa_id}`);
          // Ordenar boards por ID antes de setar no estado
          const sortedBoards = response.data.sort((a, b) => a.id - b.id);
          setBoards(sortedBoards);
          if (sortedBoards.length > 0) {
            setSelectedBoardId(sortedBoards[0].id.toString());
          }
        } catch (error) {
          console.error('Erro ao buscar boards:', error);
          setBoards([]);
        } finally {
          setLoadingBoards(false);
        }
      }
    };

    fetchBoards();
  }, [user]);



  return (
    <div className='home-page-container'>



      <Header />
      <Vendas />
      {!isMetaReviewer && <BemVindo />}
      <div className='tools-container'>









        <div>
          <button style={{ display: 'none' }} onClick={handleSendEmail} >
            Send Email
          </button>
        </div>



        {/* <MdOutlineSearch onClick={() => clearSearchTerm()} style={{ display: openCloseFilterModal || openCloseSelectAfilhadosModal || openCloseSelectDateModal ? 'none' : '', background: openCloseSearchModal ? 'dodgerblue' : '', cursor: 'pointer' }} className='search-icon-open-close' /> */}
        {openCloseSearchModal ? (
          <span
            onClick={() => clearSearchTerm()}
            className='search-icon-close'
            style={{
              backgroundColor: 'red',
              color: 'white',
              cursor: 'pointer'
            }}
          >
            X
          </span>
        ) : (
          <MdOutlineSearch

            onMouseEnter={(e) => showTooltip(e, '')} onMouseLeave={hideTooltip}
            onClick={() => clearSearchTerm()}
            style={{
              display: openCloseFilterModal || openCloseSelectAfilhadosModal || openCloseSelectDateModal ? 'none' : '',
              background: openCloseSearchModal ? 'dodgerblue' : '',
              cursor: 'pointer'
            }}
            className='search-icon-open'
          />
        )}


        {openCloseSearchModal &&

          <div className='modal-date-filter-container'>





            <div className='select-search'>


              <div className='serach-imput-container'>
                <input
                  style={{ backgroundColor: searchTerm.trim() ? '#e0e0e0' : '', color: searchTerm.trim() ? 'rgb(83, 83, 83)' : '' }}
                  className='search-card-input'
                  placeholder="Buscar Cards..."
                  value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && searchTerm.trim() !== '') {
                      handleSearchClick();
                    }
                  }}
                  onClick={(e) => {
                    e.stopPropagation(); // Previne a propagação do clique
                  }}
                />
                <MdOutlineSearch style={{ cursor: 'pointer' }} className='search-icon' onClick={(e) => {
                  e.stopPropagation(); handleSearchClick()
                }} />

              </div>


              <div className='search-type-container'>
                <label className='label-search-radio'>
                  <input
                    type="radio"
                    value="name"
                    checked={searchType === 'name'}
                    onChange={() => setSearchType('name')}
                    className='input-radio-container'
                    onClick={(e) => {
                      e.stopPropagation(); // Previne a propagação do clique
                    }}
                  />
                  Nome
                </label>

                <label className='label-search-radio'>
                  <input
                    type="radio"
                    value="nome_obra"
                    checked={searchType === 'nome_obra'}
                    onChange={() => setSearchType('nome_obra')}
                    className='input-radio-container'
                    onClick={(e) => {
                      e.stopPropagation(); // Previne a propagação do clique
                    }}
                  />
                  Nome da Obra
                </label>

                <label style={{ display: 'none' }} className='label-search-radio'>
                  <input
                    style={{ display: 'none' }}
                    type="radio"
                    value="state"
                    checked={searchType === 'state'}
                    onChange={() => setSearchType('state')}
                    className='input-radio-container'
                    onClick={(e) => {
                      e.stopPropagation(); // Previne a propagação do clique
                    }}
                  />
                  Estado
                </label>
                <label className='label-search-radio'>
                  <input
                    type="radio"
                    value="document_number"
                    checked={searchType === 'document_number'}
                    onChange={() => setSearchType('document_number')}
                    className='input-radio-container'
                    onClick={(e) => {
                      e.stopPropagation(); // Previne a propagação do clique
                    }}
                  />
                  Número do Documento
                </label>
                <label style={{ display: 'none' }} className='label-search-radio'>
                  <input
                    type="radio"
                    value="origem"
                    checked={searchType === 'origem'}
                    onChange={() => setSearchType('origem')}
                    className='input-radio-container'
                    onClick={(e) => {
                      e.stopPropagation(); // Previne a propagação do clique
                    }}
                  />
                  Origem
                </label>
                <label style={{ display: 'none' }} className='label-search-radio'>
                  <input
                    type="radio"
                    value="produto"
                    checked={searchType === 'produto'}
                    onChange={() => setSearchType('produto')}
                    className='input-radio-container'
                    onClick={(e) => {
                      e.stopPropagation(); // Previne a propagação do clique
                    }}
                  />
                  Produto
                </label>
                <label className='label-search-radio'>
                  <input
                    type="radio"
                    value="pedido_number"
                    checked={searchType === 'pedido_number'}
                    onChange={() => setSearchType('pedido_number')}
                    className='input-radio-container'
                    onClick={(e) => {
                      e.stopPropagation(); // Previne a propagação do clique
                    }}
                  />
                  Número do Pedido
                </label>



              </div>
            </div>
          </div>
        }






        {/* <MdGroups style={{ display: openCloseFilterModal || openCloseSearchModal || openCloseSelectDateModal ? 'none' : '', background: openCloseSelectAfilhadosModal ? 'dodgerblue' : '' }} onClick={() => setOpenCloseSelectAfilhadosModal(!openCloseSelectAfilhadosModal)} className='afilhados-icon-open-close' /> */}



        {openCloseSelectAfilhadosModal ? (
          <span
            onClick={() => setOpenCloseSelectAfilhadosModal(!openCloseSelectAfilhadosModal)}
            className='afilhados-icon-close'
            style={{
              backgroundColor: 'red',
              color: 'white',
              cursor: 'pointer'
            }}
          >
            X
          </span>
        ) : (
          <MdGroups
            onMouseEnter={(e) => showTooltip(e, 'Filtrar Entidades')} onMouseLeave={hideTooltip}
            style={{
              display: openCloseFilterModal || openCloseSearchModal || openCloseSelectDateModal ? 'none' : '',
              background: openCloseSelectAfilhadosModal ? 'dodgerblue' : ''
            }}
            onClick={() => setOpenCloseSelectAfilhadosModal(!openCloseSelectAfilhadosModal)}
            className='afilhados-icon-open'
          />
        )}










        {openCloseSelectAfilhadosModal && (
          <div className='modal-date-filter-container'>
            <div id="afilhadosSelect" className="select-filter">
              <label className="title-label-afilhados">Afilhados</label>
              <input
                className='input-search-afilhado-filter-afilhados'
                type="text"
                placeholder="Buscar Afilhado..."
                value={afilhadoSearchTerm}
                onChange={(e) => handleAfilhadoSearch(e.target.value)}
              />









              <div className="list-afilhados-container">
                <div
                  key="select-all"
                  className={`select-filter-option ${selectedAfilhados.length === visibleAfilhadosList.length + 1 ? 'selected' : ''}`}
                  style={{ backgroundColor: selectedAfilhados.length === visibleAfilhadosList.length + 1 ? '' : '' }}
                  onClick={handleSelectAll}
                >
                  {selectedAfilhados.length === visibleAfilhadosList.length + 1 ? 'Desselecionar Todos' : 'Selecionar Todos'}
                </div>

                <div
                  className={`select-filter-option ${showSharedCards ? 'selected' : ''}`}
                  onClick={() => setShowSharedCards(!showSharedCards)} // Alterna manualmente
                  style={{ backgroundColor: showSharedCards ? '#49b6f5' : '' }}
                >
                  {showSharedCards ? 'COMPARTILHADOS' : 'COMPARTILHADOS'}
                </div>

                <div
                  key={user.id}
                  className={`select-filter-option ${selectedAfilhados.includes(user.id) ? 'selected' : ''}`}
                  style={{ backgroundColor: selectedAfilhados.includes(user.id) ? '#49b6f5' : '' }}
                  onClick={() => handleSelectChange(user.id)}
                >
                  <img
                    className='logo-afilhado-lista'
                    src={user.avatar ? (userAvatar?.includes('syncs-avatar') ? require(`../../../assets/avatares/${userAvatar}`) : user.avatar) : logoDefault}
                  />
                  <label className='label-afilhados-lista'>
                    {user.username}
                    <label className='label-user-type' style={{ background: user.user_type == 'Administrador' ? 'red' : user.user_type == 'Supervisor' ? '#49c5ff' : '' }}>{user.user_type}</label>
                  </label>
                </div>

                {Object.entries(
                  filteredAfilhadosList.reduce((acc, afilhado) => {
                    const state = afilhado.state || 'Sem Estado'; // Adicione um fallback caso não haja estado
                    if (!acc[state]) {
                      acc[state] = [];
                    }
                    acc[state].push(afilhado);
                    return acc;
                  }, {})
                ).map(([state, afilhados]) => (
                  <React.Fragment key={state}>
                    <div className='state-divider'>{state}</div>
                    {afilhados.sort((a, b) => a.username.localeCompare(b.username)).map(afilhado => (
                      <div
                        key={afilhado.id}
                        className={`select-filter-option ${selectedAfilhados.includes(afilhado.id) ? 'selected' : ''}`}
                        style={{ backgroundColor: selectedAfilhados.includes(afilhado.id) ? '#49b6f5' : '' }}
                        onClick={() => handleSelectChange(afilhado.id)}
                      >
                        <img
                          className='logo-afilhado-lista'
                          src={afilhado.avatar ? (afilhado.avatar.includes('syncs-avatar') ? require(`../../../assets/avatares/${afilhado.avatar}`) : afilhado.avatar) : logoDefault}
                        />
                        <label className='label-afilhados-lista'>
                          {afilhado.username}

                          <label
                            className='label-user-type'
                            style={{
                              background: afilhado.user_type === 'Administrador' ? 'red' : afilhado.user_type === 'Supervisor' ? '#f54966' : ''
                            }}
                          >
                            {afilhado.user_type}
                          </label>
                        </label>

                      </div>
                    ))}
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
        )}




























        {/* <BsCalendarDate style={{ display: openCloseSearchModal || openCloseFilterModal || openCloseSelectAfilhadosModal ? 'none' : '', background: openCloseSelectDateModal ? 'red' : '' }} onClick={() => setOpenCloseSelectDateModal(!openCloseSelectDateModal)} className='afilhados-icon-open-close' /> */}

        {openCloseSelectDateModal ? (
          <span
            onClick={() => setOpenCloseSelectDateModal(!openCloseSelectDateModal)}
            className='search-icon-close'
            style={{

              backgroundColor: 'red',
              color: 'white',
              cursor: 'pointer'
            }}
          >
            X
          </span>
        ) : (
          <BsCalendarDate

            onMouseEnter={(e) => showTooltip(e, 'Filtrar Período de Busca')} onMouseLeave={hideTooltip}
            style={{
              display: openCloseSearchModal || openCloseFilterModal || openCloseSelectAfilhadosModal ? 'none' : '',
              background: openCloseSelectDateModal ? 'red' : ''
            }}
            onClick={() => setOpenCloseSelectDateModal(!openCloseSelectDateModal)}
            className='afilhados-icon-open'
          />
        )}


        {openCloseSelectDateModal && (
          <div className='modal-date-filter-container'>
            <div className='date-filter-container'>
              <div className='date-filter-row'>
                <div className='date-filter-column'>
                  <label htmlFor="tempDataInicial" className='date-filter-label'>Data Inicial</label>
                  <input
                    className='date-filter-date'
                    type="date"
                    name="tempDataInicial"
                    value={tempDataInicial}
                    onChange={handleTempDateChange}
                  />
                </div>


                <div className='date-filter-column'>
                  <label htmlFor="tempDataFinal" className='date-filter-label'>Data Final</label>
                  <input
                    className='date-filter-date'
                    type="date"
                    name="tempDataFinal"
                    value={tempDataFinal}
                    onChange={handleTempDateChange}
                  />
                </div>
              </div>

              <div className='date-filter-column'>
                <label htmlFor="dataType" className='date-filter-label'>Tipo de Data</label>
                <select
                  id="dataType"
                  value={tempDataType}
                  onChange={(e) => setTempDataType(e.target.value)}
                  className='select-etiquetas-filter'
                >
                  <option value="created_at">Data de Criação</option>
                  <option value="updated_at">Data de Atualização</option>
                </select>
              </div>


              <button className='btn-update-date-filter' onClick={handleUpdateDates}>Atualizar Datas</button>




            </div>
          </div>
        )}




        {/* <MdOutlineFilterList style={{ display: openCloseSelectAfilhadosModal || openCloseSelectDateModal || openCloseSearchModal ? 'none' : '', background: openCloseFilterModal ? 'dodgerblue' : '' }} onClick={() => setOpenCloseFilterModal(!openCloseFilterModal)} className='afilhados-icon-open-close' /> */}

        {openCloseFilterModal ? (
          <span
            onClick={() => setOpenCloseFilterModal(!openCloseFilterModal)}
            className='filter-icon-close-filter'
            style={{
              backgroundColor: 'red',
              color: 'white',
              cursor: 'pointer'
            }}
          >
            X
          </span>
        ) : (
          <MdOutlineFilterList
            onMouseEnter={(e) => showTooltip(e, 'Ordenar Cards nas Colunas')} onMouseLeave={hideTooltip}
            style={{
              display: openCloseSelectAfilhadosModal || openCloseSelectDateModal || openCloseSearchModal ? 'none' : '',
              background: openCloseFilterModal ? 'dodgerblue' : ''
            }}
            onClick={() => setOpenCloseFilterModal(!openCloseFilterModal)}
            className='afilhados-icon-open'
          />
        )}


        {openCloseFilterModal && (

          <div className='modal-date-filter-container'>
            <div className='filter-filter-container'>

              <div className='date-filter-row'>

                <div className='date-filter-column'>

                  <label htmlFor="tempDataInicial" className='date-filter-label'>Ordenar</label>

                  <div className='order-by-order'>
                    <button style={{ backgroundColor: isAscending ? 'dodgerblue' : '' }} className='btn-filter-tools-order' onClick={() => setIsAscending(true)}>
                      Crescente
                    </button>

                    <button style={{ backgroundColor: !isAscending ? 'dodgerblue' : '' }} className='btn-filter-tools-order' onClick={() => setIsAscending(false)}>
                      Decrescente
                    </button>
                  </div>



                  <button style={{ backgroundColor: orderBy === 'nome' ? 'dodgerblue' : '' }} className='btn-filter-tools' onClick={() => setOrderBy('nome')}>Nome</button>
                  <button style={{ backgroundColor: orderBy === 'dataStatus' ? 'dodgerblue' : '' }} className='btn-filter-tools' onClick={() => setOrderBy('dataStatus')}>Data de status</button>
                  <button style={{ backgroundColor: orderBy === 'dataCreate' ? 'dodgerblue' : '' }} className='btn-filter-tools' onClick={() => setOrderBy('dataCreate')}>Data de criação</button>
                  <button style={{ backgroundColor: orderBy === 'dataUpdate' ? 'dodgerblue' : '' }} className='btn-filter-tools' onClick={() => setOrderBy('dataUpdate')}>Data de atualização</button>
                  <button style={{ backgroundColor: orderBy === 'value' ? 'dodgerblue' : '' }} className='btn-filter-tools' onClick={() => setOrderBy('value')}>Valor</button>
                  <button style={{ backgroundColor: orderBy === 'task' ? 'dodgerblue' : '' }} className='btn-filter-tools' onClick={() => setOrderBy('task')}>Tarefa</button>




                </div>

              </div>






              <label htmlFor="etiquetas" className='date-filter-label'>Etiquetas</label>

              <div className='filter-select-columns'>
                <select
                  id="etiquetas"
                  value={selectedEtiqueta}
                  onChange={(e) => setSelectedEtiqueta(e.target.value)}
                  className='select-etiquetas-filter'
                >
                  <option value="">Todas as Etiquetas</option> {/* Opção para remover o filtro */}
                  {listaEtiquetas.map(etiqueta => (
                    <option key={etiqueta.id} value={etiqueta.id}>
                      {etiqueta.description}
                    </option>
                  ))}
                </select>
              </div>


              <label htmlFor="anexoSetor" className='date-filter-label'>Categoria de Anexos</label>

              <div className='filter-select-columns'>
                <select
                  id="anexoSetor"
                  value={selectedAnexoSetor || ''}
                  onChange={(e) => setSelectedAnexoSetor(e.target.value || null)}
                  className='select-etiquetas-filter'
                >
                  <option value="">Todas as Categorias</option>
                  <option value="Proposta Comercial">Proposta Comercial</option>
                  <option value="Proposta Comercial Alterada">Proposta Comercial Alterada</option>
                  <option value="Proposta Comercial Analise técnica">Proposta Comercial Analise técnica</option>
                  <option value="Check List a ser preenchido">Check List a ser preenchido</option>
                  <option value="Check List Medição">Check List Medição</option>
                  <option value="Check List Medição Alterado">Check List Medição Alterado</option>
                  <option value="Contrato Assinado">Contrato Assinado</option>
                  <option value="Contrato Não Assinado">Contrato Não Assinado</option>
                  <option value="Adiantamento Assinado">Adiantamento Assinado</option>
                  <option value="Adiantamento Não Assinado">Adiantamento Não Assinado</option>
                  <option value="Projeto da Obra">Projeto da Obra</option>
                  <option value="Sistema construtivo - Projeto executivo de modulação">Sistema construtivo - Projeto executivo de modulação</option>
                  <option value="Sistema construtivo - Produção">Sistema construtivo - Produção</option>
                  <option value="Termo de Medição Assinado">Termo de Medição Assinado</option>
                  <option value="Termo de Medição Não Assinado">Termo de Medição Não Assinado</option>
                  <option value="Mapa de Corte">Mapa de Corte</option>
                  <option value="Check List de Instalação">Check List de Instalação</option>
                  <option value="CNO">CNO</option>
                  <option value="Fotos da obra">Fotos da obra</option>
                  <option value="Observações pós medição">Observações pós medição</option>
                  <option value="Aprovação cliente">Aprovação cliente</option>
                  <option value="Alteração Interna de Pedido">Alteração Interna de Pedido</option>
                </select>
              </div>


              <label htmlFor="tipoClienteFilter" className='date-filter-label'>Tipo de Cliente</label>

              <div className='filter-select-columns'>
                <select
                  id="tipoClienteFilter"
                  value={selectedTipoCliente || ''}
                  onChange={(e) => setSelectedTipoCliente(e.target.value || null)}
                  className='select-etiquetas-filter'
                >
                  <option value="">Todos os Tipos</option>
                  {listaTiposCliente.map(tipo => (
                    <option key={tipo.id} value={tipo.id}>{tipo.name}</option>
                  ))}
                </select>
              </div>

























              <label htmlFor="tempDataInicial" className='date-filter-label'>Setores</label>


              <div className='filter-select-columns'>

                <button
                  className='btns-filter-select-columns'
                  onClick={handleSelectAllSetores}

                >
                  Selecionar Todos
                </button>
                <button
                  className='btns-filter-select-columns'
                  onClick={handleDeselectAllSetores}

                >
                  Deselecionar Todos
                </button>


                {setores.map((setor, index) => (
                  <button
                    className='btns-filter-select-columns'

                    key={index}
                    style={{
                      backgroundColor: selectedSetores.includes(setor) ? 'dodgerblue' : '#f0f0f0',
                      color: selectedSetores.includes(setor) ? 'white' : '#333',
                      transition: 'background-color 0.3s, color 0.3s',
                    }}
                    onClick={() => handleSetorChange(setor)}
                  >
                    {setor}
                  </button>
                ))}
              </div>





            </div>













          </div>
        )}





        {/* {user && getAccessLevel('exportExceljjjjjjj') &&
          <RiFileExcel2Line style={{ display: openCloseFilterModal || openCloseSelectAfilhadosModal || openCloseSelectDateModal || openCloseSearchModal ? 'none' : '' }} onClick={() => exportarTabelasExcel()} className='afilhados-icon-open-close' />
        } */}




        {/* <RiFileExcel2Line onMouseEnter={(e) => showTooltip(e, 'Exportar Dados para Excel')} onMouseLeave={hideTooltip} style={{ display: openCloseFilterModal || openCloseSelectAfilhadosModal || openCloseSelectDateModal || openCloseSearchModal ? 'none' : '' }} onClick={exportarCardsFiltrados} className='excel-icon-open' /> */}

        {getAccessLevel('exportar') && (
          <RiFileExcel2Line
            onMouseEnter={(e) => showTooltip(e, isExportingCards ? 'Exportando todos os cards...' : 'Exportar Dados para Excel')}
            onMouseLeave={hideTooltip}
            style={{
              display: openCloseFilterModal || openCloseSelectAfilhadosModal || openCloseSelectDateModal || openCloseSearchModal ? 'none' : '',
              opacity: isExportingCards ? 0.5 : 1,
              pointerEvents: isExportingCards ? 'none' : 'auto',
            }}
            onClick={exportarCardsFiltrados}
            className='excel-icon-open'
          />
        )}





        {isLocalSearchVisible && (
          <div className='buscar-localmente-container'>
            <input
              className='search-card-input-local'
              style={{ width: '100px', marginLeft: '4px', color: buscaLocal != '' ? 'red' : '', display: openCloseFilterModal || openCloseSelectAfilhadosModal || openCloseSelectDateModal || openCloseSearchModal ? 'none' : '' }}
              type="text"
              value={buscaLocal}
              onChange={(e) => {
                setBuscaLocal(e.target.value)
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && buscaLocal.trim() !== '') {
                  updateBuscaLocal();
                }
              }}
              onClick={() => setIsSearchLocalVisible(true)} // Mostra a div ao clicar
              placeholder="Busca Local..."
            />

            <MdOutlineSearch onMouseEnter={(e) => showTooltip(e, 'Buscar Cards Localmente')} onMouseLeave={hideTooltip} style={{ backgroundColor: isSearchLocalVisible ? 'deepskyblue' : '', display: openCloseFilterModal || openCloseSelectAfilhadosModal || openCloseSelectDateModal || openCloseSearchModal ? 'none' : '' }} onClick={() => updateBuscaLocal()} className='search-icon' />
          </div>
        )}


        {isSearchLocalVisible && (
          <div className='tipo-de-busca-local-container'>

            <button className='btn-close-busca-local' onClick={() => setIsSearchLocalVisible(false)}>x</button>
            <p className='search-title'>Buscar por:</p>


            <div className='search-type-container'>

              <label className='label-search-radio'>
                <input
                  type="radio"
                  value="name"
                  checked={tipoBuscaLocal === 'name'}
                  onChange={() => tipoDeBuscaLocal('name')}
                  className='input-radio-container'
                  onClick={(e) => {
                    e.stopPropagation(); // Previne a propagação do clique
                  }}
                />
                Nome
              </label>

              <label className='label-search-radio'>
                <input
                  type="radio"
                  value="produto"
                  checked={tipoBuscaLocal === 'produto'}
                  onChange={() => tipoDeBuscaLocal('produto')}
                  className='input-radio-container'
                  onClick={(e) => {
                    e.stopPropagation(); // Previne a propagação do clique
                  }}
                />
                Produto <label style={{ color: 'white', marginLeft: '6px', fontWeight: 'bold', backgroundColor: '#ff1648', padding: '2px 4px' }}>New</label>
              </label>

              <label className='label-search-radio'>
                <input
                  type="radio"
                  value="name"
                  checked={tipoBuscaLocal === 'fone'}
                  onChange={() => tipoDeBuscaLocal('fone')}
                  className='input-radio-container'
                  onClick={(e) => {
                    e.stopPropagation(); // Previne a propagação do clique
                  }}
                />
                Telefone
              </label>

              <label className='label-search-radio'>
                <input
                  type="radio"
                  value="name"
                  checked={tipoBuscaLocal === 'valor'}
                  onChange={() => tipoDeBuscaLocal('valor')}
                  className='input-radio-container'
                  onClick={(e) => {
                    e.stopPropagation(); // Previne a propagação do clique
                  }}
                />
                Valor
              </label>


              <label className='label-search-radio'>
                <input
                  type="radio"
                  value="name"
                  checked={tipoBuscaLocal === 'orcamento'}
                  onChange={() => tipoDeBuscaLocal('orcamento')}
                  className='input-radio-container'
                  onClick={(e) => {
                    e.stopPropagation(); // Previne a propagação do clique
                  }}
                />
                Número de Orçamento
              </label>

              <label className='label-search-radio'>
                <input
                  type="radio"
                  value="name"
                  checked={tipoBuscaLocal === 'pedido'}
                  onChange={() => tipoDeBuscaLocal('pedido')}
                  className='input-radio-container'
                  onClick={(e) => {
                    e.stopPropagation(); // Previne a propagação do clique
                  }}
                />
                Número de Pedido
              </label>

              <label className='label-search-radio'>
                <input
                  type="radio"
                  value="name"
                  checked={tipoBuscaLocal === 'city'}
                  onChange={() => tipoDeBuscaLocal('city')}
                  className='input-radio-container'
                  onClick={(e) => {
                    e.stopPropagation(); // Previne a propagação do clique
                  }}
                />
                Cidade
              </label>

              <label className='label-search-radio'>
                <input
                  type="radio"
                  value="name"
                  checked={tipoBuscaLocal === 'column'}
                  onChange={() => tipoDeBuscaLocal('column')}
                  className='input-radio-container'
                  onClick={(e) => {
                    e.stopPropagation(); // Previne a propagação do clique
                  }}
                />
                ID Coluna
              </label>


              <label className='label-search-radio'>
                <input
                  type="radio"
                  value="name"
                  checked={tipoBuscaLocal === 'origem'}
                  onChange={() => tipoDeBuscaLocal('origem')}
                  className='input-radio-container'
                  onClick={(e) => {
                    e.stopPropagation(); // Previne a propagação do clique
                  }}
                />
                Origem
              </label>

              <label className='label-search-radio'>
                <input
                  type="radio"
                  value="name"
                  checked={tipoBuscaLocal === 'responsavel'}
                  onChange={() => tipoDeBuscaLocal('responsavel')}
                  className='input-radio-container'
                  onClick={(e) => {
                    e.stopPropagation(); // Previne a propagação do clique
                  }}
                />
                Responsável
              </label>

              <label className='label-search-radio'>
                <input
                  type="radio"
                  value="tipo_cliente"
                  checked={tipoBuscaLocal === 'tipo_cliente'}
                  onChange={() => tipoDeBuscaLocal('tipo_cliente')}
                  className='input-radio-container'
                  onClick={(e) => {
                    e.stopPropagation(); // Previne a propagação do clique
                  }}
                />
                Tipo de Cliente
              </label>

              <label className='label-search-radio'>
                <input
                  type="radio"
                  value="motivo_perda"
                  checked={tipoBuscaLocal === 'motivo_perda'}
                  onChange={() => tipoDeBuscaLocal('motivo_perda')}
                  className='input-radio-container'
                  onClick={(e) => {
                    e.stopPropagation(); // Previne a propagação do clique
                  }}
                />
                Motivo de Perda
              </label>

              {/* <label className='label-search-radio'>
                <input
                  type="radio"
                  value="name"
                  checked={tipoBuscaLocal === 'vendidos'}
                  onChange={() => setTipoBuscaLocal('vendidos')}
                  className='input-radio-container'
                  onClick={(e) => {
                    e.stopPropagation(); // Previne a propagação do clique
                  }}
                />
                Vendidos
              </label>

              <label className='label-search-radio'>
                <input
                  type="radio"
                  value="name"
                  checked={tipoBuscaLocal === 'perdidos'}
                  onChange={() => setTipoBuscaLocal('perdidos')}
                  className='input-radio-container'
                  onClick={(e) => {
                    e.stopPropagation(); // Previne a propagação do clique
                  }}
                />
                Perdidos
              </label> */}


              <label className='label-status-card'>Status</label>
              <div className='status-container-filter'>
                <button onClick={(e) => { e.stopPropagation(); tipoDeBuscaLocal('perdidos') }} className='btn-status-perdido-filter' style={{ height: tipoBuscaLocal === 'perdidos' ? '30px' : '' }}>Perdidos</button>
                <button onClick={(e) => { e.stopPropagation(); tipoDeBuscaLocal('vendidos') }} className='btn-status-vendido-filter' style={{ height: tipoBuscaLocal === 'vendidos' ? '30px' : '' }}>Vendidos</button>
              </div>







              <label className='label-status-card'>Temperatura</label>

              {/* <div className='temperatura-container-filter'>
                {['Frio', 'Morno', 'Quente'].map((temp, index) => (
                  <button
                    key={temp}
                    data-temp={index + 1}
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleTemperatureSelection(index + 1);
                      setTipoBuscaLocal('temperatura');
                    }}
                    className={`btn-temperatura ${selectedTemperatures.includes(index + 1) ? 'selected' : ''}`}
                  >
                    {temp}
                  </button>
                ))}
              </div> */}


              <div className='temperatura-container-filter'>
                <button
                  className='btn-temperatura'

                  onClick={(e) => {
                    e.stopPropagation();
                    toggleTemperatureSelection(1);
                  }}
                  style={{
                    backgroundColor: selectedTemperatures.includes(1) ? '#c6f6ff' : '',
                    color: selectedTemperatures.includes(1) ? '#333' : '#333',
                  }}
                >
                  Frio
                </button>

                <button
                  className='btn-temperatura'

                  onClick={(e) => {
                    e.stopPropagation();
                    toggleTemperatureSelection(2);
                  }}
                  style={{
                    backgroundColor: selectedTemperatures.includes(2) ? '#fae0af' : '',
                    color: selectedTemperatures.includes(2) ? '#333' : '#333',
                  }}
                >
                  Morno
                </button>

                <button
                  className='btn-temperatura'
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleTemperatureSelection(3);
                  }}
                  style={{
                    backgroundColor: selectedTemperatures.includes(3) ? '#d2f899' : '',
                    color: selectedTemperatures.includes(3) ? '#333' : '#333',
                  }}
                >
                  Quente
                </button>
              </div>













              {/* <label className='label-temperatura-card'>Temperatura</label>
              <div className='temperatura-container-filter'>
                <button onClick={(e) => { e.stopPropagation(); tipoDeBuscaLocal('frio') }} className='btn-temperatura-frio-filter' style={{ height: tipoBuscaLocal === 'frio' ? '30px' : '' }}>Frio</button>
                <button onClick={(e) => { e.stopPropagation(); tipoDeBuscaLocal('morno') }} className='btn-temperatura-morno-filter' style={{ height: tipoBuscaLocal === 'morno' ? '30px' : '' }}>Morno</button>
                <button onClick={(e) => { e.stopPropagation(); tipoDeBuscaLocal('quente') }} className='btn-temperatura-quente-filter' style={{ height: tipoBuscaLocal === 'quente' ? '30px' : '' }}>Quente</button>
              </div> */}


            </div>

            <label className="label-search-radio-filtro-colunas">
              <input
                type="radio"
                value="name"
                checked={buscaCombinadaComColuna} // Controla o estado visual
                onClick={handleRadioClick} // Alterna o estado
                className="input-radio-container"
              />
              Filtrar coluna combinada
            </label>


            {
              <ul style={{ display: 'none' }} className='search-options-list'>
                <li><MdPerson className='search-icon-info' /> Nome do cliente</li>
                <li><MdPhone className='search-icon-info' /> Telefone</li>
                <li><MdAttachMoney className='search-icon-info' /> Custo</li>
                <li><MdDescription className='search-icon-info' /> Número do orçamento</li>
                <li><MdLocalShipping className='search-icon-info' /> Número do Pedido</li>
                <li><MdLocationCity className='search-icon-info' /> Cidade</li>
                <li><MdLabel className='search-icon-info' /> @ ID da Coluna</li>
                <li><MdPublic className='search-icon-info' /> # Origem</li>
                <li><MdPerson className='search-icon-info' /> Responsável</li> {/* Nova opção de busca */}
              </ul>

            }

          </div>
        )}





        <BsCalendarDate style={{ display: 'none' }} onClick={() => setShowGoogleCalendar(!showGoogleCalendar)} className='afilhados-icon-open-close' />

        {showGoogleCalendar && (
          <GoogleCalendario />

        )}

        <div className='btn-niveis-busca-cards'>

          <button onMouseEnter={(e) => showTooltip(e, 'Nível 1 - Buscar Cards com previsão de suas Tarefas')} onMouseLeave={hideTooltip} style={{ backgroundColor: nivelBuscaCards === 1 ? '#7d19ff' : '' }} onClick={() => setNivelBuscaCards(1)} className='btn-get-cards-especial'>N1</button>
          <button onMouseEnter={(e) => showTooltip(e, 'Nível 2 - Buscar Cards com previsão de suas Tarefas e de Afilhados')} onMouseLeave={hideTooltip} style={{ backgroundColor: nivelBuscaCards === 2 ? '#7d19ff' : '' }} onClick={() => setNivelBuscaCards(2)} className='btn-get-cards-especial'>N2</button>


        </div>

        <MdOutlineUpdate onMouseEnter={(e) => showTooltip(e, 'Atualizar Cards')} onMouseLeave={hideTooltip} style={{ display: openCloseFilterModal || openCloseSelectAfilhadosModal || openCloseSelectDateModal || openCloseSearchModal ? 'none' : '' }} onClick={() => reloadPage()} className='afilhados-icon-open' />


        {!isMetaReviewer && (
          <div>
            <button className='btn-portal' onClick={() => navigate('/portal')}>
              <img className='logo-bazze-portal' src={logoBazze} alt="Logo Bazze" />
            </button>
          </div>
        )}







     
     



        {loadingBoards ? (
          <div className="h-[30px] w-[150px] bg-gray-200 animate-pulse rounded ml-1"></div>
        ) : (
          <select
            className="select-board"
            value={selectedBoardId}
            onChange={(e) => {
              const selectedId = e.target.value;
              setSelectedBoardId(selectedId);
            }}
          >
            {boards.map(board => (
              <option key={board.id} value={board.id}>
                {board.name}
              </option>
            ))}
          </select>
        )}













      </div>




      <DragDropContext onDragEnd={handleOnDragEnd}>
        <div className='home-container'>
          {columnsUser ? (
            columnsUser
              .filter(column => selectedSetores.includes(column.setor))
              .filter(column => filteredColumnsBuscaLocal.some(filteredColumn => filteredColumn.id === column.id))
              .filter(column => column.board_id === parseInt(selectedBoardId)) // Removido a condição OR para forçar a filtragem por board
              .map(column => (
                <Column key={column.id} columnData={column} />
              ))
          ) : (
            <>sem colunas</>
          )}
        </div>
      </DragDropContext>


      {(previewSearchCards.length > 0 || loadingSearch) && (
        <div className='search-result-container'>
          {loadingSearch && (
            <div className='loading-container-search'>
              Loading...
            </div>
          )}

          {previewSearchCards.map((item) => (
            <div className='item-search-result-card' key={item.card_id} onClick={() => getCardData(item)}>
              <PreviewCard key={item.card_id} cardData={item} />
            </div>
          ))}
        </div>
      )}

      {openCloseImportExcelEntidades && <ImportExcel />}
      {openCloseImportExcelSuiteFlow && <ImportExcelSuiteFlow />}




      {/* Tooltip com posição fixa */}
      {tooltip.visible && (
        <div
          style={{
            position: 'fixed', // Fixado à tela
            top: tooltip.y,
            left: tooltip.x,
            transform: 'translate(-50%, -100%)', // Centraliza horizontalmente e posiciona acima
            background: 'black',
            color: 'white',
            padding: '5px 10px',
            borderRadius: '5px',
            whiteSpace: 'nowrap',
            zIndex: 1000,
          }}
        >
          {tooltip.text}
        </div>
      )}


    </div>
  );
}

export default HomePage;
